export const EMPTY_ADDRESS_FORM_VALUES = {
    addressLine1: '',
    addressLine2: '',
    city: '',
    postalCode: '',
    countryCode: '',
    countrySubdivisionCode: '',
};

export const fieldNames = {
    creditNoteCounterId: 'creditNoteCounterId',
} as const;
